import { render, staticRenderFns } from "./CambiaPassword.vue?vue&type=template&id=75953115&"
import script from "./CambiaPassword.vue?vue&type=script&lang=js&"
export * from "./CambiaPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports